import * as ko from 'knockout';
import { NhlGame } from './models/game';
import { NhlWeek } from './models/week';
import type { IWeek } from '../shared/interfaces/IWeek';
import { Enumerable } from '../shared/linq';

/**
 * NHL GetSchedule.
 * - 3 slots per week: Western, Eastern vs. Western, Eastern.
 * - 4 post-season weeks: RD1, RD2, Conference Finals, Stanley Cup Finals.
 */
export function GetSchedule(teams: TeamDictionary, games: IGameData[]): WeekDictionary {
  const dict: WeekDictionary = {};

  const maxWeek = Enumerable.From(games).Max((g: IGameData) => g.Week);

  for (let i = 1; i <= maxWeek; i++) {
    dict[i] = [];
    dict[i].push(new NhlWeek('Western'));
    dict[i].push(new NhlWeek('Eastern vs. Western'));
    dict[i].push(new NhlWeek('Eastern'));
  }

  for (const _gameInt in games) {
    const game: IGameData = games[_gameInt];
    if (game.Away.Conference === game.Home.Conference) {
      if (game.Away.Conference === 'Western') {
        dict[game.Week][0].games.push(
          ko.observable(
            new NhlGame(
              teams[game.Home.Conference][game.Home.Division][game.Home.TeamAbbreviation],
              teams[game.Away.Conference][game.Away.Division][game.Away.TeamAbbreviation],
              game.Week,
              game.GameScheduleNum,
              0,
              game.GameDate,
              game.GameGUID,
              game.GameKey
            )
          ) as unknown as KnockoutObservable<import('../shared/interfaces/IGame').IGame>
        );
      } else {
        dict[game.Week][2].games.push(
          ko.observable(
            new NhlGame(
              teams[game.Home.Conference][game.Home.Division][game.Home.TeamAbbreviation],
              teams[game.Away.Conference][game.Away.Division][game.Away.TeamAbbreviation],
              game.Week,
              game.GameScheduleNum,
              0,
              game.GameDate,
              game.GameGUID,
              game.GameKey
            )
          ) as unknown as KnockoutObservable<import('../shared/interfaces/IGame').IGame>
        );
      }
    } else {
      dict[game.Week][1].games.push(
        ko.observable(
          new NhlGame(
            teams[game.Home.Conference][game.Home.Division][game.Home.TeamAbbreviation],
            teams[game.Away.Conference][game.Away.Division][game.Away.TeamAbbreviation],
            game.Week,
            game.GameScheduleNum,
            0,
            game.GameDate,
            game.GameGUID,
            game.GameKey
          )
        ) as unknown as KnockoutObservable<import('../shared/interfaces/IGame').IGame>
      );
    }
  }

  // round-1
  dict[maxWeek + 1] = [];
  dict[maxWeek + 1].push(new NhlWeek('Eastern'));
  dict[maxWeek + 1].push(new NhlWeek('Eastern vs Western'));
  dict[maxWeek + 1].push(new NhlWeek('Western'));

  // round-2
  dict[maxWeek + 2] = [];
  dict[maxWeek + 2].push(new NhlWeek('Eastern'));
  dict[maxWeek + 2].push(new NhlWeek('Eastern vs Western'));
  dict[maxWeek + 2].push(new NhlWeek('Western'));

  // Conference Finals
  dict[maxWeek + 3] = [];
  dict[maxWeek + 3].push(new NhlWeek('Eastern'));
  dict[maxWeek + 3].push(new NhlWeek('Eastern vs Western'));
  dict[maxWeek + 3].push(new NhlWeek('Western'));

  // Stanley Cup Finals
  dict[maxWeek + 4] = [];
  dict[maxWeek + 4].push(new NhlWeek('Eastern'));
  dict[maxWeek + 4].push(new NhlWeek('Stanley Cup Finals'));
  dict[maxWeek + 4].push(new NhlWeek('Western'));

  return dict;
}
